export class OptionSelectors {
    constructor(target_elements,quickview) {
        this.productSection = '[product-section]';
        this.OptionSelectors = '[option-selectors]';
        this.Option = '[option]';
        this.targetElements = target_elements;
        this.quickview = quickview;
        this.init();
    }

    init() {
        if (!Array.isArray(this.targetElements)) {
            console.error('targetElements must be an array');
            return;
        }
        document.body.addEventListener('change', this.handleChange.bind(this));
    }



    async handleChange(e) {
        // check that it isn't a range slider
        if (e.target.closest(this.OptionSelectors) && e.target.type !== 'range') {
            // check if target has id is_gift and return
            if (e.target.id == 'is_gift') {
                return;
            }
            await this.setForm(e.target);
            await this.updateProduct(e.target);
        }
    }

    variantImageChange(variant,gallery_slides) {
        if (!gallery_slides) {
            return;
        }
        // const if_card = this.product_form.getAttribute('data-card');
        // if (if_card == "true") {
        //     return;
        // }
        // const is_quickview = this.product_form.closest(".quick-view-modal") ? true : false;
        gallery_slides.forEach((slide, i) => {
            let index = i + 1;
            const slide_id = slide.dataset.id;
            const slide_index = slide.dataset.index;

            // Store order as a CSS variable instead of directly setting it
            let new_index = index++;
            slide.dataset.slideOrder = new_index;
            slide.style.setProperty('--slide-order', new_index);

            if (!slide_id) return;

            const slide_variant_ids = slide_id.split(',');
            if (slide_variant_ids.includes(variant.toString())) {

                if ( gallerySwiper ) gallerySwiper.slideTo(slide_index, 500);

                // Get the slide and bring it to the front
                const slide = gallery_slides[slide_index];
                if (slide) {
                    slide.style.setProperty('--slide-order', 0);
                    slide.dataset.slideOrder = 0;
                    // console.log("there is a slide: ", slide, 'slide id: ', slide_id);
                }
            }
        });

        // Get the new order from CSS and apply classes
        const orderedSlides = [...gallery_slides]
            .sort((a, b) => a.style.getPropertyValue('--slide-order') - b.style.getPropertyValue('--slide-order'));

        orderedSlides.forEach((slide, i) => {
            slide.classList.remove("big-image", "small-image", "first-slide", "second-slide");

            if ( i  === 0 ) {
                slide.classList.add("first-slide");
            } else if ( i === 1 ) {
                slide.classList.add("second-slide");
            }

            if (i % 3 === 0) {
                slide.classList.add("big-image"); // Every 3rd image (0-based index) is big
            } else {
                slide.classList.add("small-image"); // The rest are small
            }
        });

    }


    async setForm(target) {
        const form = target.closest(this.productSection).querySelector('product-form form');
        this.form = form;
        if (!form) return;
        await this.setSectionId(form);
        await this.setProductId(form);
        await this.setUpdateHTML(form);
        await this.getOldProductURL(form);
        await this.getInputType(target);
        await this.getVariantId(target);
        await this.setNewProductURL(target);
        if (this.quickview) {
            await this.setQuickviewURL(form);
        }
    }

    async getInputType(target) {
        return new Promise((resolve) => {
            if (target.tagName == 'SELECT') {
                this.inputType = 'select';
                resolve();
            } else {
                this.inputType = 'radio';
                resolve();
            }
        });
    }

    async setNewProductURL(target) {
        return new Promise((resolve) => {
            if (this.inputType == 'select') {
                const selectedOption = target.options[target.selectedIndex];
                this.newProductUrl = selectedOption.getAttribute('data-product-url');
                resolve();
            } else {
                const newProductUrl = target.getAttribute('data-product-url');
                this.newProductUrl = newProductUrl;
                resolve();
            }
        });
    }

    async setSectionId(form) {
        return new Promise((resolve) => {
            const sectionId = form.getAttribute('data-section-id');
            this.sectionId = sectionId;
            resolve();
        });
    }

    async setQuickviewURL(form) {
        return new Promise((resolve) => {
            const qvProductURL = form.closest(this.productSection).getAttribute('data-product-url-qv');
            this.qvProductURL = qvProductURL;
            resolve();
        });
    }

    async setProductId(form) {
        return new Promise((resolve) => {
            const productId = form.getAttribute('data-product-id');
            this.productId = productId;
            resolve();
        });
    }

    async getOldProductURL(form) {
        return new Promise((resolve) => {
            const oldProductURL = form.getAttribute('data-product-url');
            this.oldProductURL = oldProductURL;
            resolve();
        });
    }

    async getVariantId(target) {
        return new Promise((resolve) => {
            if (this.inputType == 'select') {
                const selectedOption = target.options[target.selectedIndex];
                this.variantId = selectedOption.getAttribute('data-variant-id');
                resolve();
            } else {
                const variantId = target.getAttribute('data-variant-id');
                this.variantId = variantId;
                resolve();
            }
        });
    }

    async setUpdateHTML(form) {
        this.HTMLSelector = this.productSection;
        const updateHTML = form.closest(this.HTMLSelector);
        this.updateHTML = updateHTML;
    }

    updateURL(newURL, variantId) {
        const url = new URL(window.location);
        url.pathname = newURL; // Update the base URL

        if (variantId) {
            url.searchParams.set('variant', variantId); // Set or update the variant parameter
        } else {
            url.searchParams.delete('variant'); // Remove the variant parameter if no ID is provided
        }

        window.history.replaceState({}, '', url.toString());
    }

    // updateSwipers(newHTML) {
    //     // Check if the element exists
    //     const scriptElement = newHTML.querySelector("[gallery-swipers]");

    //     if (scriptElement) {
    //     // Get the text content of the <script> element
    //         let gallery_swipers = scriptElement.textContent;

    //         // Clean up the content if necessary (be very cautious here)
    //         // Check first if we have the tags in the content.
    //         if(gallery_swipers.includes("</script>") && gallery_swipers.includes("<script gallery-swipers>")){
    //             gallery_swipers = gallery_swipers.replace("</script>", "").replace("<script gallery-swipers>", "");
    //         }
    //         try{
    //             new Function(gallery_swipers)();
    //         } catch(error){
    //             console.error("Error executing script:",error);
    //         }
    //         // Get closest this.productSection from this.form
    //         // const productSection = document.querySelector(`#ProductSection-${this.sectionId}-${this.productId}`);
    //         // if (!productSection) {
    //         //     return;
    //         // }
    //         const gallery_slides = productSection.querySelectorAll('[main-gallery] .main-swiper-slide');
    //         // console.log("🚀 ~ OptionSelectors ~ .then ~ productSection:", productSection)

    //         if (gallery_slides.length > 0) {
    //             this.variantImageChange(this.variantId, gallery_slides);
    //         }
    //     } else {
    //         console.warn("No element found with the 'gallery-swipers' attribute.");
    //     }
    // }

    callback() {
        // Callback function
    }


    async updateProduct(target) {

        this.targetElements.forEach((element) => {
            const oldElement = this.updateHTML.querySelector(element);
            if (!oldElement) {
                console.log("Can't find old element: ",element);
                return;
            }
            oldElement.classList.add('deselect');
        });

        let params = `section_id=${this.sectionId}&`;

        if (this.variantId) {
            // If the option value has a variant selection, call the section rendering api for that variant
            params += `variant=${this.variantId}`;
        } else {
            console.log("no variant id");
            // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
            // const selectedOptionValues = Array.from(this.updateHTML.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
            // params += `option_values=${selectedOptionValues}`;
        }

        let url = this.newProductUrl;

        if (this.quickview) {
            url = this.qvProductURL;
        }

        // Call the section rendering api
        fetch(`${url}?${params}`)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newHTML = html.querySelector(this.HTMLSelector);
            if (this.newProductUrl && this.oldProductURL !== this.newProductUrl) {
                const parent = this.updateHTML.parentNode;
                parent.insertAdjacentHTML('beforeend', newHTML.outerHTML);
                this.updateHTML.remove();
                document.querySelector(`#${target.id}`).focus();
                // update page url
                this.updateURL(this.newProductUrl, this.variantId);
                this.updateSwipers(newHTML);
                return;
            }

            this.targetElements.forEach((element) => {
                const newElement = newHTML.querySelector(element);
                const oldElement = this.updateHTML.querySelector(element);
                if (!oldElement) {
                    console.log("Can't find old element: ",element);
                    return;
                }
                if (!newElement) {
                    console.log("Can't find new element: ",element);
                    return;
                }
                oldElement.classList.remove('deselect');
                oldElement.innerHTML = newElement.innerHTML;
            });

            if (this.inputType == 'select') {
                // If the target is a select element, select the option based on the variant ID
                // const selectElement = document.querySelector(`#${target.id}`);
                // selectElement.value = this.variantId;
            } else {
                document.querySelector(`#${target.id}`).focus();
            }
            if (!this.quickview) {
                this.updateURL(this.oldProductURL, this.variantId);
            }
            // const gallery_slides = document.querySelectorAll('[main-gallery] .main-swiper-slide');
            // if (gallery_slides.length > 0) {
            //     this.variantImageChange(this.variantId, gallery_slides);
            // } else {
            //     console.log("No gallery slides found");
            // }
            this.callback();

        });
    }
}